import AbstractVertical from './AbstractVertical'

export default class Parcs extends AbstractVertical {

  readonly name: string = 'parcs'
  readonly title: string = 'PARCS'
  readonly color: string = '#5456aa'

  readonly supportedFeatures: string[] = [
    'showOnUniversalInventoryCalendar',
  ]

}
